
$(document).ready(function() {

    $('.logout').live('click',function() {
        url = '/register/ajax/';
        datasend = {};
        datasend.action = 'logout';
        $.ajax({
            url: url,
            type: "POST",
            data: datasend,
            async: true,
            success: function(response) {
               window.location = '/';
            },
            dataType: 'html'
        });


    });

    $('.register-user').ajaxForm({
        beforeSubmit: function(formData, jqForm, options) {
            jqForm.find('.form-i').removeClass('error');
            jqForm.find('.error-msg').text('');
            document.body.style.cursor = 'wait';
        },
        dataType: 'html',
        success: function(response, status, xhr, jqForm) {
            document.body.style.cursor = 'default';
            response = jQuery.parseJSON(response);
            if (response.result == 1) {
                hidepop($(".js-pop-reg"));
                $('.js-pop-success-reg').find('.personal-link').attr('href',response.link);
                showpop($(".js-pop-success-reg"));
                header_auth = '<div><a href="'+response.link+'" class="header-auth-link _user">'+response.login+'</a></div>'+
                            '<div><a href="#" class="header-auth-link logout">Выйти</a></div>';
                $('.header-auth').html(header_auth);
            }
            else {
                for (var error_field in response.errors) {
                    jqForm.find('input[name="' + error_field + '"]').parents('.form-i').addClass('error');
                }
                jqForm.find('.error-msg').text(response.error_message);
            }
        }
    });

    $('.user-login').ajaxForm({
        beforeSubmit: function(formData, jqForm, options) {
            jqForm.find('.form-i').removeClass('error');
            jqForm.find('.error-msg').text('');
            document.body.style.cursor = 'wait';
        },
        dataType: 'html',
        success: function(response, status, xhr, jqForm) {
            document.body.style.cursor = 'default';
            response = jQuery.parseJSON(response);
            if (response.result == 1) {
                if (typeof window.deliveryPage != "undefined" &&
                    window.deliveryPage == true &&
                    typeof window.deliveryPageAfterSocialAuth == "function"
                ) {//Отменяем перезагрузку страницы
                    window.hidepop($('.user-login').closest('.pop')) //Скрываем всплывающая окно
                    window.deliveryPageAfterSocialAuth() //Заполняем данные формы
                }
                else
                    location.reload(true);
            }
            else {
                for (var error_field in response.errors) {
                    jqForm.find('input[name="' + error_field + '"]').parents('.form-i').addClass('error');
                }
                jqForm.find('.error-msg').text(response.error_message);
            }
        }
    });

    $('.user-forgot').ajaxForm({
        beforeSubmit: function(formData, jqForm, options) {
            jqForm.find('.form-i').removeClass('error');
            jqForm.find('.error-msg').text('');
            document.body.style.cursor = 'wait';
        },
        dataType: 'html',
        success: function(response, status, xhr, jqForm) {
            document.body.style.cursor = 'default';
            response = jQuery.parseJSON(response);

            if (response.result == 1) {
                jqForm.parent().find('.success-msg').html(response.message);
                jqForm.parent().find('.pop-form-success').show();
                jqForm.hide();
            }
            else {
                for (var error_field in response.errors) {
                    jqForm.find('input[name="' + error_field + '"]').parents('.form-i').addClass('error');
                }
                jqForm.find('.error-msg').text(response.error_message);
            }
        }
    });

});